import { serverInfo } from '../config/serverConfig';
import { getAuthHeaders } from './authHeaders';

const base = serverInfo.serverUrl;

/**
 * Fetch list of object types (Super Admin tool).
 * @returns {{ success: boolean, objectTypes: { id: string, label: string }[] }}
 */
export async function fetchObjectTypes() {
  const headers = await getAuthHeaders();
  const res = await fetch(base + '/dataManagement/objectTypes', { headers });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Failed to load object types');
  return data;
}

/**
 * Preview counts for selected tenant, object types, and includeRelated.
 * @param {{ account_id: string, objectTypes: string[], includeRelated: boolean, performed_by?: string }} body
 */
export async function previewDataManagement(body) {
  const headers = await getAuthHeaders();
  const res = await fetch(base + '/dataManagement/preview', {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Preview failed');
  return data;
}

/**
 * Export data as JSON. Returns { payload, counts }.
 * @param {{ account_id: string, objectTypes: string[], includeRelated: boolean, performed_by?: string }} body
 */
export async function exportDataManagement(body) {
  const headers = await getAuthHeaders();
  const res = await fetch(base + '/dataManagement/export', {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Export failed');
  return data;
}

/**
 * Delete data (cascade within tenant).
 * @param {{ account_id: string, objectTypes: string[], includeRelated: boolean, performed_by?: string }} body
 */
export async function deleteDataManagement(body) {
  const headers = await getAuthHeaders();
  const res = await fetch(base + '/dataManagement/delete', {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Delete failed');
  return data;
}

/**
 * Copy or move data to another tenant.
 * @param {{ source_account_id: string, target_account_id: string, objectTypes: string[], includeRelated: boolean, mode: 'copy'|'move', performed_by?: string }} body
 */
export async function moveDataManagement(body) {
  const headers = await getAuthHeaders();
  const res = await fetch(base + '/dataManagement/move', {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Move failed');
  return data;
}

/**
 * Fetch audit log entries (Super Admin only).
 * @param {{ limit?: number }} body
 */
export async function fetchAuditLog(body) {
  const headers = await getAuthHeaders();
  const res = await fetch(base + '/dataManagement/auditLog', {
    method: 'POST',
    headers,
    body: JSON.stringify(body || {}),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Failed to load audit log');
  return data;
}
